import { combineReducers } from 'redux';
import { auditListReducer } from './reducers/audit-list-reducer';

export default combineReducers({
  auditListReducer
});
